import React from "react";
import { Drawer, List, IconButton, Divider } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import propTypes from "prop-types";

import clsx from "clsx";

import useStyles from "./stylesDrawer";
import SidebarItems from "./SidebarItems";

import logo from "../../images/logo.png";

const UserDrawer = ({
  open = true,
  currentItemHandler = () => {},
  handleDrawerClose = () => {}
}) => {
  const classes = useStyles();

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose)
      }}
    >
      <div className={classes.toolbarIcon}>
        {<img src={logo} style={{width:'100%'}} />}
        <img src="https://drenvio.com/wp-content/uploads/2020/04/logo-dr-envio-pagweb-01.png" style={{width:'100px'}}/>,
        <IconButton onClick={() => handleDrawerClose()}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List>
        <SidebarItems currentItemHandler={currentItemHandler} />
      </List>
      
    </Drawer>
  );
};

UserDrawer.propTypes = {
  open: propTypes.bool,
  currentItemHandler: propTypes.func,
  handleDrawerClose: propTypes.func
};

export default UserDrawer;
